export class EntityAdapter {
    // #region Vars
    entity;
    entityDomain;
    entityAddress;
    appHost;
    idField;
    fields;
    fixedFilters;
    getArgs;
    // #endregion
    // #region Constructor
    constructor(options) {
        this.appHost = options.appHost;
        this.entity = options.entity;
        this.fields = this.getFieldsAsArray(options.selectFields);
        this.fixedFilters = options.fixedFilters ?? [];
        this.idField = options?.instanceKeyFields ?? (options?.keyFields ?? 'id');
        this.getArgs = options?.getArgs;
        this.entityDomain = this.entity?.domain;
        this.entityAddress = this.appHost.entities.getEntityAddress(this.entity);
    }
    // #endregion
    // #region Load
    async loadAll(_query, _searchFields) {
        // #region Query
        let tQuery = {
            select: this.fields
        };
        //Filters
        {
            this.buildDataFilter(tQuery, undefined, this.fixedFilters);
        }
        // #endregion
        // #region Execute
        let tResult = await this.appHost.api.post(`${this.entityDomain}/api/system.entities/${this.entityAddress}/$select`, tQuery, { params: { '$input': 'dx-query', '$format': 'datasource' } });
        // #endregion
        // #region Generic-DataSource
        let tSource = utils.getDataSourceData(tResult.data, false);
        // #endregion
        return tSource;
    }
    async loadPage(query, page, pageSize, _searchFields, signal) {
        // #region Init
        if (page === 0) {
            page = 1;
        }
        // #endregion
        // #region Query
        let tQuery = {
            searchOperation: "contains",
            searchValue: query,
            select: this.fields,
            searchExpr: this.fields,
            skip: (page - 1) * pageSize,
            take: pageSize
        };
        //Filters
        {
            this.buildDataFilter(tQuery, undefined, this.fixedFilters);
        }
        // #endregion
        // #region Execute
        let tResult = await this.appHost.api.post(`${this.entityDomain}/api/system.entities/${this.entityAddress}/$select`, tQuery, { params: { '$input': 'dx-query', '$format': 'datasource' }, signal: signal });
        // #endregion
        // #region Generic-DataSource
        let tData = utils.getDataSourceData(tResult.data, false);
        {
            if (!tData) {
                return { items: [], hasMore: false };
            }
            else {
                return {
                    items: tData,
                    hasMore: Array.isArray(tData) && tData.length >= pageSize
                };
            }
        }
        // #endregion
    }
    async loadById(id) {
        // #region Query
        let tQuery = {
            select: this.fields,
            skip: 0,
            take: 1,
            filter: [[this.idField, id]]
        };
        //Filters
        {
            this.buildDataFilter(tQuery, undefined, this.fixedFilters);
        }
        // #endregion
        // #region Execute
        let tResult = await this.appHost.api.post(`${this.entityDomain}/api/system.entities/${this.entityAddress}/$select`, tQuery, { params: { '$input': 'dx-query', '$format': 'datasource' } });
        // #endregion
        // #region Generic-DataSource
        let tData = utils.getDataSourceData(tResult.data, false);
        {
            if (!tData && tData.length === 0) {
                return null;
            }
            else {
                return tData[0];
            }
        }
        // #endregion
    }
    // #endregion
    // #region Helper
    buildDataFilter(data, sourceData, filter) {
        // #region Vars
        if (!data) {
            return;
        }
        if (!filter || !utils.isArray(filter) || filter.length === 0) {
            return;
        }
        if (!data.filter || data.fiter === undefined) {
            data.filter = [];
        }
        // #endregion
        // #region Args
        let tArgs = this.getArgs ? (this.getArgs() ?? {}) : {};
        // #endregion
        // #region Filter
        for (let f of filter) {
            let tValue = undefined;
            {
                if (f.member) {
                    tValue = utils.getObjectValue(tArgs?.self, f.member);
                }
                else if (f.expression) {
                    tValue = utils.evalParams(f.expression, { ...tArgs });
                }
                else if (f.value) {
                    tValue = f.value;
                }
            }
            if (f.filterID) {
                data.filter.push(['@' + f.filterID, tValue]);
            }
            else {
                data.filter.push([f.name, f.operator ?? '=', tValue]);
            }
        }
        // #endregion
    }
    getFieldsAsArray(source) {
        let tKeyFields = source;
        {
            if (tKeyFields && utils.isArray(tKeyFields)) {
                return tKeyFields;
            }
            else if (tKeyFields && utils.isString(tKeyFields)) {
                return tKeyFields.split(',');
            }
        }
        return [];
    }
}
